export default "__VITE_ASSET__NMgMLnAV__"